import React from 'react';
interface TimelineItemProps {
  era: string;
  title: string;
  description: string;
  meta?: string;
  color: 'magenta' | 'cyan' | 'lime' | 'orange';
}
export function TimelineItem({
  era,
  title,
  description,
  meta,
  color
}: TimelineItemProps) {
  const borderColors = {
    magenta: 'border-brand-magenta',
    cyan: 'border-brand-cyan',
    lime: 'border-brand-lime',
    orange: 'border-brand-orange'
  };
  return <div className={`pl-6 border-l-4 ${borderColors[color]} py-2 mb-8 last:mb-0`} data-id="element-141">
      <span className="block text-lg font-bold text-brand-black mb-1" data-id="element-142">
        {era}
      </span>
      <h3 className="text-2xl font-black uppercase mb-3 text-brand-black" data-id="element-143">
        {title}
      </h3>
      <p className="text-gray-700 mb-3 leading-relaxed" data-id="element-144">{description}</p>
      {meta && <p className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-145">
          {meta}
        </p>}
    </div>;
}